module.exports = __webpack_public_path__ + "i18n/fr.c8ace4a62ce633369fa2399656ded5df.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1002
// module chunks = 60